import { Injectable } from '@angular/core';
import { ToastService } from 'src/packages/mitsBasics';

@Injectable()
export class ImportHelper {
  constructor(private readonly toastService: ToastService) {}

  /**
   * Opens a file dialog to import a JSON-File
   * @returns the imported JSON-Object
   */
  async importJson(type: string): Promise<any> {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.json';
    const data = JSON.parse(await this.openDialog(input));
    if (this.isOfType(data, type)) {
      delete data.exportObjectType;
      delete data.exportVersion;
      return data;
    } else {
      this.toastService.danger($localize`Die Datei ist nicht vom erwateten Typ ` + type);
      throw new Error('The given file is not of the given type');
    }
  }

  private isOfType(obj: any, type: string): boolean {
    return obj.exportObjectType === type;
  }

  /**
   * Opens a given input element as a dialog
   * @param input to open
   * @returns data as string from the input-file
   */
  private async openDialog(input: HTMLInputElement): Promise<string> {
    return new Promise((resolve) => {
      input.onchange = (e: any) => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          resolve(e.target.result);
        };
        reader.readAsText(file);
      };
      input.click();
    });
  }
}
